<template>
  <div class="navbar-header d-xl-block d-none">
    <ul class="nav navbar-nav">
      <li class="nav-item">
        <b-link
          class="navbar-brand navbar-brand--official"
          to="/"
        >
          <span class="brand-logo brand-logo--official">
            <b-img
              :src="currentAppLogoImage"
              :alt="appLogoAlt"
            />
          </span>
          <h2
            v-if="appName"
            class="brand-text mb-0"
          >
            {{ appName }}
          </h2>
        </b-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { BLink, BImg } from 'bootstrap-vue'
import { computed } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    BLink,
    BImg,
  },
  setup() {
    // App Name
    const {
      appName,
      appLogoImage,
      appLogoImageDark,
      appLogoAlt,
    } = $themeConfig.app
    const { skin } = useAppConfig()
    const currentAppLogoImage = computed(() => (skin.value === 'dark' && appLogoImageDark ? appLogoImageDark : appLogoImage))

    return {
      appName,
      currentAppLogoImage,
      appLogoAlt,
    }
  },
}
</script>

<style>

</style>
